<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 mt-2 text-center">
        <h4 class="text-center">Terms & Details</h4>
      </div>
      <div class="col-md-12 mt-3">
        <ul>
          <li>Order Dates:</li>
          <ul>
            <li>2/9/2026 - 2/28/2026</li>
          </ul>
        </ul>
        <ul>
          <li>Payment Terms:</li>
          <ul>
            <li>Regular terms apply</li>
          </ul>
        </ul>
        <ul>
          <li>Minimum Order:</li>
          <ul>
            <li>Prepaid freight</li>
          </ul>
        </ul>
        <ul>
          <li>Dropships:</li>
          <ul>
            <li>These orders will ship directly from the manufacturer. Because of this, Lancaster has limited control of shipping dates.</li>
            <li>Dropship orders are subject to each vendor’s prepaid and freight policies.</li>
          </ul>
        </ul>
        <ul>
          <li>Pool Buys:</li>
          <ul>
            <li>These orders contain items that are not normally stocked in our distribution centers. Lancaster will order these items based on show purchases. Please allow additional shipping time for Pool Buy products.</li>
          </ul>
        </ul>
        <ul>
          <li>Shipping:</li>
          <ul>
            <li>Orders will ship from our distribution centers by common carrier, with the exception of drop shipments.</li>
            <li>Option A</li>
            <ul>
              <li>A-F will ship the week of February 16th</li>
              <li>G-O will ship the week of February 23rd</li>
              <li>P-Z will ship the week of March 2nd</li>
            </ul>
          </ul>
          <ul>
            <li>Option B</li>
            <ul>
              <li>A-F will ship the week of March 16th</li>
              <li>G-O will ship the week of March 23rd</li>
              <li>P-Z will ship the week of March 30th</li>
            </ul>
            <li>Store names that start with “The” or “A”, for example, The Paint Store, will fall under the P’s as Paint Store. All orders must ship by April 30, 2026; any open orders or back orders will be cancelled after April 30th.</li>
          </ul>
        </ul>
      </div>
    </div>
  </div>
</template>